import {
  Col,
  Form,
  Grid,
  Input,
  InputNumber,
  Row,
  Select,
  SelectProps,
} from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { genderEnum } from "../../enumerations/genderEnum";
import { UserLevelResponse } from "../../hooks/UserLevel/data";
import { useGetUserLevels } from "../../hooks/UserLevel/userlevel.hooks";
import { InputRequired } from "../../validations/validations";
import { P2 } from "../NormalFonts";
import "./styles.scss";

const CompanionForm = ({
  index,
  className,
  skillCode,
}: {
  index: number;
  className?: any;
  skillCode: string | undefined;
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { data: userLevels } = useGetUserLevels({});
  const [levelOptions, setLevelOptions] = useState<SelectProps["options"]>([]);
  const [genderOptions, setGenderOptions] = useState<SelectProps["options"]>(
    [],
  );

  const getColSpan = () => {
    if (screens.lg) return 6;
    if (screens.sm) return 12;
    return 24;
  };

  useEffect(() => {
    if (!userLevels) return;
    const levels = userLevels.map((level: UserLevelResponse) => {
      return {
        label: t(`userlevel.${level.level_code}`),
        value: level.level_code,
      };
    });
    setLevelOptions(
      levels.filter((level) => level.value.startsWith(skillCode || "SB")),
    );
  }, [userLevels]);

  useEffect(() => {
    setGenderOptions(
      genderEnum.map((gender: any) => {
        return {
          label: t(`gender.${gender.value}`),
          value: gender.value,
        };
      }),
    );
  }, []);

  return (
    <Row gutter={[12, 12]} className={className}>
      <Col span={getColSpan()}>
        <Form.Item
          name={`full_name_${index}`}
          label={
            <P2 color="var(--Neutral-dark-70)">
              {t("checkout.data.fullname.title")}
            </P2>
          }
          rules={[InputRequired(t, "checkout.data.fullname.title")]}
        >
          <Input placeholder={t("checkout.data.fullname.hint")} />
        </Form.Item>
      </Col>
      <Col span={getColSpan()}>
        <Form.Item
          name={`nickname_${index}`}
          label={
            <P2 color="var(--Neutral-dark-70)">
              {t("checkout.data.nickname.title")}
            </P2>
          }
        >
          <Input placeholder={t("checkout.data.nickname.hint")} />
        </Form.Item>
      </Col>
      <Col span={getColSpan()}>
        <Form.Item
          name={`gender_${index}`}
          label={
            <P2 color="var(--Neutral-dark-70)">{t("profile.gender.title")}</P2>
          }
          rules={[InputRequired(t, "profile.gender.title")]}
        >
          <Select
            options={genderOptions}
            placeholder={t("profile.gender.hint")}
          />
        </Form.Item>
      </Col>
      <Col span={getColSpan()}>
        <Form.Item
          name={`age_${index}`}
          label={
            <P2 color="var(--Neutral-dark-70)">
              {t("checkout.data.age.title")}
            </P2>
          }
          rules={[
            InputRequired(t, "checkout.data.age.title"),
            {
              type: "number",
              min: 4,
              message: t("checkout.data.age.restrict"),
            },
          ]}
        >
          <InputNumber
            className="custom-number-input"
            placeholder={t("checkout.data.age.hint")}
          />
        </Form.Item>
      </Col>
      {levelOptions && levelOptions?.length > 0 && (
        <Col span={24}>
          <Form.Item
            name={`skill_level_code${index}`}
            label={
              <P2 color="var(--Neutral-dark-70)">
                {t("checkout.data.skill.title")}
              </P2>
            }
            initialValue={levelOptions[0].value}
          >
            <Select
              options={levelOptions}
              popupClassName="companion-skill-select-popup"
            />
          </Form.Item>
        </Col>
      )}
    </Row>
  );
};

export default CompanionForm;
